import { NoteGenerationErrorCode } from '@/features/note-generation/noteGenerationErrors';
import { formatMessageOutsideReact } from '@/utils/i18n/intl-bridge';
import { toast } from '@heidi/design-system/toast';
import { streamResponseMessages } from '../legacy/_stream-response.messages';

export function toastGenerationStoppedAndRestored(): void {
  toast({
    title: 'Generating stopped and previous version restored',
  });
}

export function toastGenerationStopped(): void {
  toast({
    title: 'Generating stopped',
  });
}

export function toastSectionalConversionFailed(): void {
  toast({
    tone: 'destructive',
    title: formatMessageOutsideReact(
      streamResponseMessages.sectionalConversionFailedTitle
    ),
    description: formatMessageOutsideReact(
      streamResponseMessages.sectionalConversionFailedDescription
    ),
  });
}

/**
 * Pre-redesign toast for an unavailable template, one per code. Used with the
 * pro-actions flag OFF, and for Haiku either way (it mounts no picker).
 * Pre-formatted strings, not `FormattedMessage` elements, so toast error
 * tracking can extract an identifiable message.
 */
export function toastUnavailableTemplate(code: string): void {
  switch (code) {
    case NoteGenerationErrorCode.TeamTemplateAccessDenied:
      toast({
        // Stable E2E selector.
        'data-testid': 'note-generation-team-template-access-toast',
        tone: 'destructive',
        title: 'Error',
        description:
          'You do not have access to this team template, please contact your administrator',
      });
      return;
    case NoteGenerationErrorCode.TemplateDeleted:
    case NoteGenerationErrorCode.TemplateNotFound:
      toast({
        // Stable E2E selector.
        'data-testid': 'note-generation-template-deleted-toast',
        tone: 'destructive',
        title: formatMessageOutsideReact(streamResponseMessages.templateUnavailableTitle),
        description: formatMessageOutsideReact(
          streamResponseMessages.templateDeletedDescription
        ),
      });
      return;
    default:
      toast({
        // Stable E2E selector.
        'data-testid': 'note-generation-template-unavailable-toast',
        tone: 'destructive',
        title: formatMessageOutsideReact(streamResponseMessages.templateUnavailableTitle),
        description: formatMessageOutsideReact(
          streamResponseMessages.templateUnavailableDescription
        ),
      });
  }
}
